import React, { Component, Fragment } from "react";
import User_menu from "./user-menu";
import Language from "./language";
import { connect } from "react-redux";
import { AlignLeft, Maximize2, MoreHorizontal } from "react-feather";
import "./Header.css";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import { change_Lang } from "../../../actions/Helper_action";
import { LogOut } from "../../../actions/Auth_action";

export class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebar: true,
      rightSidebar: true,
      navMenus: false,
    };
  }
  toggle() {
    this.setState((prevState) => ({
      navMenus: !prevState.navMenus,
    }));
  }
  showRightSidebar = () => {
    if (this.state.rightSidebar) {
      this.setState({ rightSidebar: false });
      document.querySelector(".right-sidebar").classList.add("show");
    } else {
      this.setState({ rightSidebar: true });
      document.querySelector(".right-sidebar").classList.remove("show");
    }
  };
  goFull = () => {
    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  };
  openCloseSidebar = () => {
    if (this.state.sidebar) {
      this.setState({ sidebar: false });
      document.querySelector(".page-main-header").classList.add("open");
      document.querySelector(".page-sidebar").classList.add("open");
    } else {
      this.setState({ sidebar: true });
      document.querySelector(".page-main-header").classList.remove("open");
      document.querySelector(".page-sidebar").classList.remove("open");
    }
  };
  steNavMenuClose = () => {
    this.setState({ navMenus: false, sidebar: true }, () => {
      if (this.state.sidebar) {
        this.setState({ sidebar: false });
        document.querySelector(".page-main-header").classList.add("open");
        document.querySelector(".page-sidebar").classList.add("open");
      } else {
        this.setState({ sidebar: true });
        document.querySelector(".page-main-header").classList.remove("open");
        document.querySelector(".page-sidebar").classList.remove("open");
      }
    });
  };
  render() {
    const { user, lang } = this.props;
    const token = window.localStorage.getItem("token_GPC_admin");
    return (
      <Fragment>
        {/* open */}
        <div className="page-main-header ">
          <div className="main-header-right row">
            <div className="main-header-left d-lg-none">
              <div className="logo-wrapper">
                {isMobile !== true ? (
                  <div className="logo-wrapper">
                    <a>
                      {token ? (
                        <img
                          className="blur-up lazyloaded"
                          src={`/${user.image}`}
                          alt=""
                        />
                      ) : (
                        ""
                      )}
                      <i className="mr-1">Zangin</i>
                    </a>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="mobile-sidebar">
              <div className="media-body text-right switch-sm">
                <label className="switch">
                  <a onClick={this.openCloseSidebar}>
                    <AlignLeft />
                  </a>
                </label>
              </div>
            </div>
            <div
              className="yusifs"
              data-text="Zangin For Best Feature"
              style={{
                margin: "auto",
                marginLeft: `${lang === "en" ? "320px" : ""}`,
                marginRight: `${lang === "en" ? "" : "320px"}`,
              }}
            >
              <Link to="/dashboard" style={{ color: "#4064d7" }}>
                Zangin For Best Feature
              </Link>
            </div>
            <div className="nav-right col">
              <ul
                className={"nav-menus " + (this.state.navMenus ? "open" : "")}
              >
                {/* <li>
                                    <SearchHeader />
                                </li> */}
                <li className="d-flex justify-content-end mt-0">
                  {isMobile !== true ? (
                    <a onClick={this.goFull} className="text-dark">
                      <Maximize2 />
                    </a>
                  ) : null}
                </li>
                <li className="onhover-dropdown mt-3">
                  <a className="txt-dark">
                    <h6 className={`${this.props.lang === "en" ? "" : "fk"}`}>
                      {this.props.lang === "en"
                        ? "English"
                        : this.props.lang === "arb"
                        ? "عربی"
                        : this.props.lang === "krd"
                        ? "کوردی"
                        : ""}
                    </h6>
                  </a>
                  <Language steNavMenuClose={this.steNavMenuClose} />
                </li>
                {isMobile !== true ? (
                  <>
                    <li className="onhover-dropdown mt-3  ">
                      <Link to={"/"}>
                        <h6
                          onClick={() => this.props.LogOut()}
                          className={`${this.props.lang === "en" ? "" : "fk"}`}
                        >
                          {this.props.change_Lang("s_logout")}
                        </h6>
                      </Link>
                    </li>
                  </>
                ) : (
                  ""
                )}
                {isMobile !== true ? "" : <User_menu />}
              </ul>
              <div
                className="d-lg-none mobile-toggle pull-right"
                onClick={() => this.toggle()}
              >
                <MoreHorizontal />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    user: state.AuthReducer.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    LogOut: () => dispatch(LogOut()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);
